import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItem {
  id: string;
  title: string;
  content: string;
}
export function HelpInfo() {
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);
  const toggleAccordion = (id: string) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };
  const accordionItems: AccordionItem[] = [{
    id: 'accordion-1',
    title: 'Full-Service Auto & Truck Repair',
    content: `Garrett Auto & Truck Repair Service provides mechanical repair, towing, and road service for cars, pickup trucks, semi trucks, industrial and commercial vehicles, construction equipment such as bulldozers, road graders, excavators, dump trucks, and farm tractors, as well as farm equipment, machinery, and trailers.

We offer a wide range of automotive and truck repair services, including general mechanic work, DOT inspections, diesel engine repair, automotive repair, light truck repair, and semi truck and trailer repair. Our capabilities also cover drivetrain repair, suspension repair, brake jobs, steering system work, transmission repair, and more for personal, commercial, and fleet vehicles in and around Farmington Hills and the greater Detroit metro area.`
  }, {
    id: 'accordion-2',
    title: 'Decades of Experience in Farmington Hills',
    content: `A great deal has changed in the years since we began serving the repair and maintenance needs of our friends and neighbors here in Farmington Hills. In 1971, Ten Mile was still a dirt road.

From our early days working on farm equipment and trucks for local farmers to today's fleet maintenance and repair solutions for corporate clients both large and small, Garrett Auto & Truck has grown up with this community. That long history helps us deliver better advice, more accurate diagnoses, and repair recommendations that make sense for both your vehicle and your budget.`
  }, {
    id: 'accordion-3',
    title: 'Expert Mechanics & Fleet Maintenance',
    content: `Our full-time mechanics are licensed, certified in their specialties, and bring over 50 years of collective experience in maintaining and repairing all types of vehicles. We are fully qualified to handle everything from tire repairs and brake jobs to alignments, four-wheel-drive repairs, axle work, and complete auto and truck engine overhauls.

We are also a premier provider of fleet maintenance and repair in Farmington Hills and the Detroit metro area. We help business owners keep their vehicles on the road and productive with thorough inspections, accurate diagnostics, and repairs that address the root cause of the problem.`
  }, {
    id: 'accordion-4',
    title: 'Specialized Diesel & Medium-Duty Truck Repair',
    content: `Garrett Auto & Truck specializes in diesel and medium-duty truck repair. Our technicians are experienced with Ford diesel trucks—including 7.3L, 6.0L, and other Power Stroke engines—as well as GM and Chevy trucks with Duramax and other gasoline and diesel engines.

We diagnose, overhaul, and rebuild engines and related systems so work trucks run reliably and deliver the power and torque they were designed for. We also service a wide range of commercial and work vehicles used in construction, agriculture, delivery, and service industries.

Ford SuperDuty Gas and Diesel Truck Repairs

Our expert mechanics service Ford SuperDuty trucks including F-150, F-250, F-350, F-450, F-550, F-650 and F-750, covering maintenance, diagnostics and repair for work trucks and commercial fleets.`
  }, {
    id: 'accordion-5',
    title: 'DOT Inspection, Diesel & Truck Repair Focus',
    content: `Garrett Auto & Truck is widely known for DOT inspections, diesel truck repair, semi-truck repair, Ford truck repair, and GM/Chevy truck repair, serving southeastern Michigan and the Detroit metro community.

Whether you need a required inspection, a drivability concern diagnosed, or a major repair on a work truck, we combine our experience and equipment to get your vehicle back in service quickly and safely.`
  }, {
    id: 'accordion-6',
    title: 'Ford Gas & Diesel Engine Information',
    content: `<div class="space-y-4">
        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Ford Medium Duty Truck Service</h4>
          <p class="text-gray-700">
            Garrett Auto & Truck Service provides complete maintenance and repair for Ford F650 and F750 trucks, including brake service, oil and filter changes, alignments, DOT inspections, diagnostics, and full repairs. Whether gas or diesel powered, our technicians keep your medium-duty trucks on the road and working reliably.
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Ford 7.3L Gas Engine Overview</h4>
          <p class="text-gray-700">
            The Ford 7.3L V8 is a naturally aspirated gasoline engine known for its durability and high performance under demanding commercial use. It delivers strong power output for heavy applications while maintaining relatively efficient fuel consumption for a large gasoline V8. Routine maintenance includes oil and filter changes, spark plug service, and periodic inspections.
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Common 7.3L Gas Engine Problems</h4>
          <p class="text-gray-700">
            Commercial operators may experience issues such as ignition coil failures, oil leaks, sensor faults, and exhaust manifold concerns. Timely inspections and proper maintenance help reduce downtime and extend engine life.
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">6.7L Power Stroke Turbo Diesel Engine</h4>
          <p class="text-gray-700">
            Ford's 6.7L Power Stroke V8 turbo diesel engine provides high torque at low RPM, ideal for towing and hauling. It uses advanced fuel injection, a variable-geometry turbocharger, and modern emissions control systems. Maintenance includes oil and filter changes, fuel system checks, air induction inspections, and emission system monitoring.
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Benefits of Ford Gas & Diesel Engines</h4>
          <ul class="list-disc list-inside space-y-0.5 text-gray-700">
            <li>Strong low-RPM torque for hauling and towing</li>
            <li>Long engine life with proper commercial-grade maintenance</li>
            <li>Advanced turbo and fuel-injection systems improve power and efficiency</li>
            <li>Ideal for service fleets, contractors, towing companies, and municipal vehicles</li>
          </ul>
        </div>
      </div>`
  }, {
    id: 'accordion-7',
    title: 'Isuzu Gas & Diesel Truck Information',
    content: `<div class="space-y-4">
        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Isuzu NPR</h4>
          <p class="text-gray-700">
            Regular maintenance includes oil and filter changes, driveline inspections, transmission fluid checks, and brake system service. Technicians monitor performance-related concerns and address wear items promptly for dependable daily operation.
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Isuzu NPR-HD</h4>
          <p class="text-gray-700">
            Similar to the NPR, but configured for heavier-duty commercial work. Requires more frequent inspections of cooling systems, transmission components, and suspension parts—especially for vehicles carrying heavy payloads.
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Isuzu NPR-XD</h4>
          <p class="text-gray-700">
            Designed specifically for diesel-driven commercial applications. Maintenance includes fuel system checks, turbocharger inspection, drivetrain service for U-joints, and periodic tire balancing—particularly important for vehicles driven on rough terrain.
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Isuzu NQR</h4>
          <p class="text-gray-700">
            The NQR relies on regular diesel system service, including particulate filter monitoring, frame and chassis inspections, hydraulic checks, and emissions-related component upkeep.
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Isuzu NRR</h4>
          <p class="text-gray-700">
            The heaviest-duty model in the Isuzu lineup, requiring clutch service (for manual trucks), transmission inspection, axle lubrication, and routine hydraulic maintenance.
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Isuzu Service Notes</h4>
          <p class="text-gray-700">
            Heavy-duty commercial trucks require frequent, scheduled maintenance to ensure reliability. Depending on load, usage, and operating conditions, Garrett Auto & Truck Service customizes service intervals to maximize uptime and performance.
          </p>
        </div>
      </div>`
  }, {
    id: 'accordion-8',
    title: 'Commercial & Fleet Truck Service Information',
    content: `<div class="space-y-4">
        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Fleet Maintenance Solutions</h4>
          <p class="text-gray-700">
            Garrett Auto & Truck Service delivers complete fleet repair and maintenance packages for commercial vehicles. Services include brake repair, suspension work, driveline service, alignments, engine repair, diagnostics, and routine maintenance for mixed fleets (gasoline and diesel).
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Light-, Medium-, and Heavy-Duty Truck Support</h4>
          <p class="text-gray-700">
            Our technicians handle work trucks, vans, medium-duty platforms, and diesel-powered commercial vehicles. Routine maintenance combined with professional troubleshooting helps prevent expensive downtime and breakdowns.
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Common Commercial Service Items</h4>
          <ul class="list-disc list-inside space-y-0.5 text-gray-700">
            <li>Brake system repair and replacement</li>
            <li>Suspension and steering work</li>
            <li>Transmission service and fluid exchange</li>
            <li>Cooling system repairs</li>
            <li>Exhaust system and emissions components</li>
            <li>Electrical and wiring diagnostics</li>
          </ul>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Engine Replacement & Major Repairs</h4>
          <p class="text-gray-700">
            For diesel and gasoline commercial engines, we provide full replacement, rebuild, or high-level repair services. This includes Power Stroke, Duramax, and commercial Isuzu engines. All work is performed by diesel-certified technicians.
          </p>
        </div>
      </div>`
  }, {
    id: 'accordion-9',
    title: 'Preventive Maintenance & Care Tips',
    content: `<div class="space-y-4">
        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Why Preventive Maintenance Matters</h4>
          <p class="text-gray-700">
            Commercial trucks experience significantly higher wear than personal vehicles. Proactive maintenance reduces breakdowns, preserves engine life, and keeps fleets operating efficiently with minimal downtime.
          </p>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Key Maintenance Items</h4>
          <ul class="list-disc list-inside space-y-0.5 text-gray-700">
            <li>Oil and filter changes at proper intervals</li>
            <li>Transmission fluid checks</li>
            <li>Fuel system and filter service (critical for diesel engines)</li>
            <li>Cooling system inspections to prevent overheating</li>
            <li>Suspension and steering checks for wear</li>
            <li>Brake pad, disc, and fluid inspections</li>
          </ul>
        </div>

        <div>
          <h4 class="font-bold text-lg mb-1 text-gray-900">Driver & Owner Tips</h4>
          <p class="text-gray-700 mb-2">
            Always monitor dashboard warnings, unusual sounds, performance changes, and fluid levels. Early reporting of issues prevents costly repairs and keeps vehicles safe and reliable.
          </p>
          <p class="text-gray-700">
            Garrett Auto & Truck Repair Service believes in preventative maintenance. Oil filter replacement, air filter replacement, and other routine services keep vehicles running longer and better. We help you save time and money by providing the diagnostic, repair, and replacement services recommended by your vehicle's manufacturer.
          </p>
        </div>
      </div>`
  }, {
    id: 'accordion-10',
    title: 'About Garrett Auto & Truck Service',
    content: `<p>

Garrett Auto & Truck Repair Service has served Southeast Michigan since 1958. Our technicians deliver reliable automotive and truck repairs with a commitment to honesty, accuracy, and long-term customer relationships. We aim to protect your investment, reduce downtime, and ensure your vehicle operates safely and efficiently.

</p>

<p>

We perform high-quality automotive and truck repairs at fair prices, using proven, high-quality materials. Our work is backed by a personal pledge of customer satisfaction, and we stand behind our workmanship on every job.

</p>`
  }];
  return <section id="help-info" className="py-20 relative bg-gray-50" data-id="element-676">
      {/* Lighter Parallax Background */}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed opacity-10" style={{
      backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/7AE3vqAVHWN4BoD6LVaH2T/Help-Center-BG.png)'
    }} data-id="element-677"></div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10" data-id="element-678">
        <div className="max-w-4xl mx-auto" data-id="element-679">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center border-b-4 border-[#B1050B] pb-4 inline-block w-full" data-id="element-680">
            Help & Info Articles
          </h2>

          <div className="space-y-4" data-id="element-681">
            {accordionItems.map(item => <div key={item.id} className="border border-gray-300 bg-white shadow-md rounded-lg overflow-hidden" data-id="element-682">
                <button onClick={() => toggleAccordion(item.id)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-683">
                  <h3 className="text-xl font-bold text-gray-900 pr-4" data-id="element-684">
                    {item.title}
                  </h3>
                  <ChevronDownIcon size={24} className={`text-[#B1050B] flex-shrink-0 transition-transform duration-200 ${openAccordion === item.id ? 'transform rotate-180' : ''}`} data-id="element-685" />
                </button>

                {openAccordion === item.id && <div className="px-6 pb-6 border-t border-gray-200 bg-white" data-id="element-686">
                    <div className="pt-6 text-gray-700 leading-tight whitespace-pre-line [&_h4]:leading-tight [&_p]:leading-normal [&_ul]:leading-normal" dangerouslySetInnerHTML={{
                __html: item.content
              }} data-id="element-687" />
                  </div>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}